// javascript
// frontend/src/GestorCambioEstados/GestorEstadoTramite.js
import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PersonIcon from '@mui/icons-material/Person';
import PlaceIcon from '@mui/icons-material/Place';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaidIcon from '@mui/icons-material/Paid';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import cambioEstadoService from '../services/cambioEstadoService';
import EventoService from '../services/eventoService';
import NotificacionService from '../services/notificacionService';
import { listarMedicos } from '../services/medicoService';
import { useRef } from 'react';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { subirArchivo, obtenerArchivosPorTramite, descargarArchivo, eliminarArchivo } from '../services/archivoService';
import DatosMaestrosService from '../services/datosMaestrosService';
import ModalAgregarGastoMedico from '../components/GastosMedicosComponentes/ModalAgregarGastoMedico';
import ComboboxDatosMaestros from '../components/ComboboxDatosMaestros';
import BotonWhatsapp from '../components/BotonWhatsapp';
import ModificarEventoModal from '../components/ModificarEventoModal';

//COMPONENTES ESPECÍFICOS PARA ESTADOS
import GestorEstadoTurnoAnses from './GestorEstadoTurnoAnses';
import GestorEstadoJuntaMedica from './GestorEstadoJuntaMedica';
import GestorEstadoEsperaDictamen from "./GestorEstadoEsperaDictamen";
import GestorEstadoPrimeraApelacion from "./GestorEstadoPrimeraApelacion";
import GestorEstadoEsperaDictamenCMC from "./GestorEstadoEsperaDictamenCMC";
import GestorEstadoSegundaApelacion from "./GestorEstadoSegundaApelacion";
import GestorEstadoTramiteEnJuicio from "./GestorEstadoTramiteEnJuicio";
import GestorEstadoEsperaFechaPericia from "./GestorEstadoEsperaFechaPericia";
import GestorEstadoPericiaAsignada from "./GestorEstadoPericiaAsignada";
import GestorEstadoEsperaDictamenTribunal from "./GestorEstadoEsperaDictamenTribunal";
import GestorEstadoSentenciaJudicial from "./GestorEstadoSentenciaJudicial";

// Función auxiliar para obtener la fecha actual en formato YYYY-MM-DD
const obtenerFechaActual = () => {
    const hoy = new Date();
    return hoy.toISOString().split('T')[0];
};

// --- COMPONENTE REUTILIZABLE PARA EL FORMULARIO DE TURNO ---
const FormularioTurno = ({ visible, onConfirmar, onCancelar, cargando, medicos, cargandoMedicos, lugares = [], onLugarCreado }) => {
    const [datosTurno, setDatosTurno] = useState({
        fecha: obtenerFechaActual(),
        hora: '',
        idMedico: '',
        lugar: '',
        observaciones: ''
    });

    useEffect(() => {
        // Resetea el formulario cuando se oculta
        if (!visible) {
            setDatosTurno({ fecha: obtenerFechaActual(), hora: '', idMedico: '', lugar: '', observaciones: '' });
        }
    }, [visible]);


    if (!visible) return null;

    return (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            <h5 className="fw-semibold text-secondary mb-3">Datos del Nuevo Turno</h5>
            <div className="row g-3">
                <div className="col-md-6">
                    <label className="form-label fw-semibold">Fecha</label>
                    <div className="input-group">
                        <span className="input-group-text bg-light"><CalendarMonthIcon fontSize="small" /></span>
                        <input type="date" className="form-control shadow-sm" value={datosTurno.fecha} onChange={(e) => setDatosTurno({ ...datosTurno, fecha: e.target.value })} required />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label fw-semibold">Hora</label>
                    <div className="input-group">
                        <span className="input-group-text bg-light"><AccessTimeIcon fontSize="small" /></span>
                        <input type="time" className="form-control shadow-sm" value={datosTurno.hora} onChange={(e) => setDatosTurno({ ...datosTurno, hora: e.target.value })} required />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label fw-semibold">Médico</label>
                    <div className="input-group">
                        <span className="input-group-text bg-light"><PersonIcon fontSize="small" /></span>
                        <select className="form-select shadow-sm" value={datosTurno.idMedico} onChange={(e) => setDatosTurno({ ...datosTurno, idMedico: e.target.value })} disabled={cargandoMedicos} required>
                            <option value="">Seleccionar médico...</option>
                            {medicos.map(medico => (
                                <option key={medico.idMedico} value={medico.idMedico}>
                                    {medico.nombre} {medico.apellido} {medico.matricula ? `(Mat: ${medico.matricula})` : ''}
                                </option>
                            ))}
                        </select>
                    </div>
                    {cargandoMedicos && <small className="text-muted">Cargando médicos...</small>}
                </div>
                <div className="col-md-6">
                    <ComboboxDatosMaestros
                        opciones={lugares.filter(l => l.tipo === 'Consultorio' || !l.tipo)}
                        valor={datosTurno.lugar}
                        onChange={(valor) => setDatosTurno({ ...datosTurno, lugar: valor })}
                        tipo="lugar"
                        tipoLugar="Consultorio"
                        placeholder="Seleccione o escriba un lugar..."
                        label="Lugar"
                        icon={PlaceIcon}
                        onCrearNuevo={onLugarCreado}
                    />
                </div>
                <div className="col-12">
                    <label className="form-label fw-semibold">Observaciones</label>
                    <textarea className="form-control shadow-sm" rows="3" placeholder="Indicaciones especiales, preparación necesaria, etc." value={datosTurno.observaciones} onChange={(e) => setDatosTurno({ ...datosTurno, observaciones: e.target.value })} />
                </div>
            </div>
            <div className="d-flex justify-content-center gap-3 mt-4">
                <button className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" onClick={() => onConfirmar(datosTurno)} disabled={cargando || !datosTurno.fecha || !datosTurno.hora || !datosTurno.idMedico}>
                    {cargando ? 'Asignando...' : <><CheckCircleIcon fontSize="small" /> Confirmar Turno</>}
                </button>
                <button className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold" onClick={onCancelar} disabled={cargando}>
                    Cancelar
                </button>
            </div>
        </div>
    );
};


function GestorEstadoTramite({ tramite, onEstadoCambiado }) {
    const [mostrarFormularioTurno, setMostrarFormularioTurno] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [medicos, setMedicos] = useState([]);
    const [lugares, setLugares] = useState([]);
    const [cargandoMedicos, setCargandoMedicos] = useState(false);
    const [turnoInfo, setTurnoInfo] = useState(null);
    const [cargandoTurno, setCargandoTurno] = useState(false);
    const [archivos, setArchivos] = useState([]);
    const [cargandoArchivos, setCargandoArchivos] = useState(false);
    const [subiendoArchivos, setSubiendoArchivos] = useState(false);
    const [dragActive, setDragActive] = useState(false);
    const fileInputRef = useRef(null);
    const [historialEstados, setHistorialEstados] = useState([]);
    const [cargandoHistorial, setCargandoHistorial] = useState(false);
    const [mostrarFormularioAprobacion, setMostrarFormularioAprobacion] = useState(false);
    const [observacionAprobacion, setObservacionAprobacion] = useState('');
    const [mostrarModalGasto, setMostrarModalGasto] = useState(false);
    const [idMedicoParaGasto, setIdMedicoParaGasto] = useState(null);
    const [cargandoLugares, setCargandoLugares] = useState(false);

    // Estado 2: Turno Médico Asignado
    const [mostrarReprogramar, setMostrarReprogramar] = useState(false);
    const [motivoReprogramacion, setMotivoReprogramacion] = useState('');
    const [mostrarInputComentario, setMostrarInputComentario] = useState(false);
    const [comentarioEstudios, setComentarioEstudios] = useState('');
    const [mostrarModificar, setMostrarModificar] = useState(false);
    const [datosTurno, setDatosTurno] = useState({
        fecha: obtenerFechaActual(),
        hora: '',
        idMedico: '',
        lugar: '',
        observaciones: ''
    });

    useEffect(() => {
        cargarMedicos();
        cargarLugares();
        cargarTurnoActual();
        cargarArchivos();
        cargarHistorial();
    }, [tramite.idTramite, tramite.idEstadoActual]);

    const cargarHistorial = async () => {
        setCargandoHistorial(true);
        try {
            const data = await cambioEstadoService.getHistorialEstados(tramite.idTramite);
            // Normaliza fechas porque el backend puede devolver fechaHora o fechaHoraInicio.
            const obtenerFechaCambio = (cambio) => cambio?.fechaHora || cambio?.fechaHoraInicio || null;
            const historialOrdenado = [...data].sort((a, b) => {
                const fechaA = obtenerFechaCambio(a) ? new Date(obtenerFechaCambio(a)).getTime() : 0;
                const fechaB = obtenerFechaCambio(b) ? new Date(obtenerFechaCambio(b)).getTime() : 0;
                return fechaB - fechaA;
            });
            setHistorialEstados(historialOrdenado);
        } catch (err) {
            console.error('Error al cargar historial:', err);
        } finally {
            setCargandoHistorial(false);
        }
    };

    const obtenerFechaCambio = (cambio) => cambio?.fechaHora || cambio?.fechaHoraInicio || null;

    const obtenerCambioMasRecientePorEstado = (idEstadoBuscado) => {
        return historialEstados.find(c => Number(c.idEstado) === Number(idEstadoBuscado)) || null;
    };

    const cargarMedicos = async () => {
        setCargandoMedicos(true);
        try {
            const data = await listarMedicos(true);
            setMedicos(data);
        } catch (error) {
            console.error("Error al cargar médicos:", error);
            toast.error("Error al cargar la lista de médicos.");
        } finally {
            setCargandoMedicos(false);
        }
    };

    const cargarLugares = async () => {
        setCargandoLugares(true);
        try {
            const response = await DatosMaestrosService.getLugares();
            // Asegurarse de que `data` exista y sea un array
            setLugares(response.data || []);
        } catch (error) {
            console.error("Error al cargar lugares:", error);
            toast.error("Error al cargar la lista de lugares.");
            setLugares([]); // Fallback a un array vacío en caso de error
        } finally {
            setCargandoLugares(false);
        }
    };

    const cargarArchivos = async () => {
        setCargandoArchivos(true);
        try {
            const data = await obtenerArchivosPorTramite(tramite.idTramite);
            const archivosBackend = data.map(archivo => ({
                id: archivo.idArchivo,
                idArchivo: archivo.idArchivo,
                nombre: archivo.nombreOriginal,
                tamaño: (archivo.tamano / (1024 * 1024)).toFixed(2) + " MB",
                estado: "subido",
                esDelBackend: true,
                tipoMime: archivo.tipoMime
            }));
            setArchivos(archivosBackend);
        } catch (error) {
            console.error("Error al cargar archivos:", error);
            toast.error("No se pudieron cargar los documentos existentes.");
        } finally {
            setCargandoArchivos(false);
        }
    };

    const cargarTurnoActual = async () => {
        setCargandoTurno(true);
        try {
            const response = await EventoService.getEventosPorTramite(tramite.idTramite);
            const eventos = response.data;
            const ultimoEventoTurno = eventos.filter(e => e.tipoEvento === 'Turno Médico').pop();
            setTurnoInfo(ultimoEventoTurno || null);
        } catch (error) {
            console.error("Error al cargar detalles del turno:", error);
            toast.error("No se pudieron cargar los detalles del turno asignado.");
        } finally {
            setCargandoTurno(false);
        }
    };

    // Función para asignar turno con médico (Estado 1 -> 2 o 3 -> 2)
    const handleAsignarTurno = async (datosTurno) => {
        if (!datosTurno.fecha || !datosTurno.hora || !datosTurno.idMedico) {
            toast.error('Debe seleccionar fecha, hora y médico');
            return;
        }

        setCargando(true);
        try {

            const medicoSeleccionado = medicos.find(m => m.idMedico === parseInt(datosTurno.idMedico));
            const nombreMedico = medicoSeleccionado ? `${medicoSeleccionado.nombre} ${medicoSeleccionado.apellido}` : 'No especificida';

            const eventoData = {
                titulo: `Turno Médico - ${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`,
                lugar: datosTurno.lugar || '',
                descripcion: `Médico: ${nombreMedico} - Lugar: ${datosTurno.lugar || 'No especificado'} - Observación: ${datosTurno.observaciones || 'No especificadas'}`,
                fecha: datosTurno.fecha,
                horaInicio: datosTurno.hora,
                horaFin: calcularHoraFin(datosTurno.hora, 60),
                todoElDia: false,
                tipoEvento: 'Turno Médico',
                idTramite: tramite.idTramite,
                visibilidad: 'POR_AREA',
                canalesNotificacion: {
                    whatsapp: false,
                    email: false,
                    inapp: true
                }
            };
            
            // Crear evento con manejo robusto de errores
            // Si fallan las notificaciones, el evento igual se crea
            try {
                await EventoService.crearEvento(eventoData);
                console.log('✅ Evento creado exitosamente');
            } catch (error) {
                // Si hay error al crear el evento, propagarlo
                console.error('❌ Error al crear evento:', error);
                throw error;
            }

            // Disparar evento personalizado para actualizar el calendario
            try {
                console.log('📅 GestorEstadoTramite: Evento creado - disparando actualización del calendario...');
                window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { 
                    detail: { timestamp: Date.now(), source: 'tramite' } 
                }));
            } catch (error) {
                // Si falla el evento personalizado, no es crítico, solo loguear
                console.warn('⚠️ No se pudo disparar el evento personalizado:', error);
            }

            const comentario = tramite.idEstadoActual === 3
                ? `Nuevo turno de control asignado tras revisión de documentación.\nFecha: ${formatearFecha(datosTurno.fecha)} ${datosTurno.hora}\nMédico: ${nombreMedico}`
                : `Turno asignado\nFecha: ${formatearFecha(datosTurno.fecha)}\nHora: ${datosTurno.hora}\nMédico: ${nombreMedico}\nLugar: ${datosTurno.lugar || 'No especificado'}\nObservación: ${datosTurno.observaciones || 'No especificadas'}`;

            const cambioEstadoData = { idEstado: 2, comentario };
            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);

            toast.success('Turno asignado y evento creado correctamente');
            setMostrarFormularioTurno(false);

            if (onEstadoCambiado) {
                onEstadoCambiado();
            }
        } catch (error) {
            console.error('Error al asignar turno:', error);
            toast.error('Error al asignar el turno: ' + (error.response?.data || error.message));
        } finally {
            setCargando(false);
        }
    };

    const handleNuevoLugarCreado = (nuevoLugar) => {
        // Agrega el nuevo lugar a la lista de lugares en el estado.
        // Esto asegura que el combobox se actualice inmediatamente.
        setLugares(prevLugares => [...prevLugares, nuevoLugar]);
        toast.info(`Nuevo lugar "${nuevoLugar.nombre}" creado.`, { autoClose: 2000 });
    };

    const handleConfirmarAprobacionMedica = async () => {
        // Si la observación está vacía, se usa un comentario por defecto.
        const comentarioFinal = observacionAprobacion.trim() || 'Trámite aprobado por el médico.';

        // Se llama a la función genérica para cambiar al estado 4 (Aprobación Médica)
        // y se pasa la observación como comentario.
        await handleRegistrarResultado(4, comentarioFinal);

        // Se limpia y oculta el formulario después de que la operación se complete.
        setMostrarFormularioAprobacion(false);
        setObservacionAprobacion('');
    };

    const handleDerivarAAnses = async () => {
        // Aquí se podría abrir un modal para pedir más detalles si fuera necesario.
        const comentarioDerivacion = 'El trámite ha sido aprobado por el médico y se deriva a ANSES para el siguiente paso.';
        // Llama a la función genérica para cambiar al estado 5 (Turno ANSES)
        await handleRegistrarResultado(5, comentarioDerivacion);
    };

    // Función para reprogramar turno
    const handleReprogramarTurno = async () => {
        if (!datosTurno.fecha || !datosTurno.hora || !datosTurno.idMedico) {
            toast.error('Debe seleccionar nueva fecha, hora y médico');
            return;
        }

        if (!motivoReprogramacion.trim()) {
            toast.error('Debe indicar el motivo de la reprogramación');
            return;
        }

        setCargando(true);
        try {

            // 1️⃣ Eliminar el evento del turno anterior si existe
            if (turnoInfo && turnoInfo.idEvento) {
                await EventoService.eliminarEvento(turnoInfo.idEvento);
            }

            // 2️⃣ Crear el nuevo evento para el turno reprogramado
            const medicoSeleccionado = medicos.find(m => m.idMedico === parseInt(datosTurno.idMedico));
            const nombreMedico = medicoSeleccionado
                ? `${medicoSeleccionado.nombre} ${medicoSeleccionado.apellido}`
                : 'No especificada';

            const nuevoEventoData = {
                titulo: `Turno Médico (Reprogramado) - ${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`,
                lugar: datosTurno.lugar || '',
                descripcion: `Médico: ${nombreMedico} - Lugar: ${datosTurno.lugar || 'No especificado'} - Observación: ${datosTurno.observaciones || 'No especificadas'}`,
                fecha: datosTurno.fecha,
                horaInicio: datosTurno.hora,
                horaFin: calcularHoraFin(datosTurno.hora, 60),
                todoElDia: false,
                tipoEvento: 'Turno Médico',
                idTramite: tramite.idTramite,
                visibilidad: 'POR_AREA',
                canalesNotificacion: {
                    whatsapp: false,
                    email: false,
                    inapp: true
                }
            };
            await EventoService.crearEvento(nuevoEventoData);

            // 3️⃣ Registrar el cambio de estado con el comentario de reprogramación
            const cambioEstadoData = {
                idEstado: 2,
                comentario: `REPROGRAMACIÓN\nMotivo: ${motivoReprogramacion}\nNueva fecha: ${formatearFecha(datosTurno.fecha)}\nHora: ${datosTurno.hora}\nMédico: ${nombreMedico}\nLugar: ${datosTurno.lugar || 'No especificado'}\nObservación: ${datosTurno.observaciones || 'No especificadas'}`
            };
            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);

            toast.success('Turno reprogramado correctamente');
            setMostrarReprogramar(false);
            setMotivoReprogramacion('');
            resetearFormulario();

            if (onEstadoCambiado) {
                onEstadoCambiado(); // Refresca los datos del trámite y del turno
            }
        } catch (error) {
            console.error('Error al reprogramar turno:', error);
            toast.error('Error al reprogramar el turno');
        } finally {
            setCargando(false);
        }
    };

    // Función para marcar no asistió
    const handleNoAsistio = async () => {
        setCargando(true);
        try {
            const cambioEstadoData = {
                idEstado: 2,
                comentario: `⚠️ INASISTENCIA - El cliente no asistió al turno.`
            };

            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);

            toast.warning('Inasistencia registrada');
            setMostrarReprogramar(true);

            if (onEstadoCambiado) {
                onEstadoCambiado();
            }
        } catch (error) {
            console.error('Error al registrar inasistencia:', error);
            toast.error('Error al registrar la inasistencia');
        } finally {
            setCargando(false);
        }
    };

    // Función para registrar resultado de consulta
    const handleRegistrarResultado = async (siguienteEstado, comentario) => {
        setCargando(true);
        try {
            const cambioEstadoData = {
                idEstado: siguienteEstado,
                comentario: comentario
            };

            await cambioEstadoService.cambiarEstado(tramite.idTramite, cambioEstadoData);

            toast.success('Resultado registrado correctamente');

            if (onEstadoCambiado) {
                // Esperamos a que el padre termine de refrescar los datos
                await onEstadoCambiado();
            }
        } catch (error) {
            console.error('Error al registrar resultado:', error);
            toast.error('Error al registrar el resultado');
        } finally {
            setCargando(false);
        }
    };

    const handleConfirmarSolicitudEstudios = async () => {
        if (!comentarioEstudios.trim()) {
            toast.warn('Por favor, detalle los estudios o documentos solicitados.');
            return;
        }
        // Esperamos a que el cambio de estado y el refresco de datos se completen
        await handleRegistrarResultado(3, comentarioEstudios);

        // Solo limpiamos el formulario después de que todo se haya completado
        setMostrarInputComentario(false);
        setComentarioEstudios('');
    };

    // Funciones auxiliares
    const calcularHoraFin = (horaInicio, minutos) => {
        if (!horaInicio) return '';
        const [horas, mins] = horaInicio.split(':').map(Number);
        const fecha = new Date();
        fecha.setHours(horas, mins + minutos, 0);
        return fecha.toTimeString().slice(0, 5);
    };

    const formatearFecha = (fechaString) => {
        if (!fechaString) return '';
        // Intentar crear una fecha. Si no es válida, devolver un string vacío.
        const fecha = new Date(fechaString);
        if (isNaN(fecha.getTime())) {
            return ''; // Devuelve vacío si la fecha no es válida
        }
        // Asegurar que la fecha se interpreta en la zona horaria local
        const fechaLocal = new Date(fecha.valueOf() + fecha.getTimezoneOffset() * 60000);
        return fechaLocal.toLocaleDateString('es-ES', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    const resetearFormulario = () => {
        setDatosTurno({
            fecha: obtenerFechaActual(),
            hora: '',
            idMedico: '',
            lugar: '',
            observaciones: ''
        });
    };

// javascript
// --- FUNCIONES PARA GESTIÓN DE ARCHIVOS ---

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleSeleccionarArchivos({ target: { files: e.dataTransfer.files } });
        }
    };

    const handleSeleccionarArchivos = (event) => {
        const files = Array.from(event.target.files || []);
        if (files.length === 0) return;

        const nuevosArchivos = files.map(file => ({
            id: `local_${Date.now()}_${Math.random()}`,
            file,
            nombre: file.name,
            tamaño: (file.size / (1024 * 1024)).toFixed(2) + " MB",
            estado: "pendiente",
            esDelBackend: false
        }));

        setArchivos(prev => [...prev, ...nuevosArchivos]);
        if (event.target) event.target.value = "";
    };

    const handleSubirArchivos = async () => {
        const archivosPendientes = archivos.filter(a => a.estado === 'pendiente');
        if (archivosPendientes.length === 0) {
            toast.info("No hay archivos nuevos para subir.");
            return;
        }

        setSubiendoArchivos(true);
        let subidosConExito = 0;

        for (const archivo of archivosPendientes) {
            try {
                const archivoSubido = await subirArchivo(tramite.idTramite, archivo.file);
                setArchivos(prev => prev.map(item =>
                    item.id === archivo.id ? {
                        ...item,
                        estado: "subido",
                        idArchivo: archivoSubido.idArchivo,
                        esDelBackend: true
                    } : item
                ));
                subidosConExito++;
            } catch (error) {
                console.error(`Error subiendo ${archivo.nombre}:`, error);
                setArchivos(prev => prev.map(item =>
                    item.id === archivo.id ? { ...item, estado: "error" } : item
                ));
            }
        }

        setSubiendoArchivos(false);
        if (subidosConExito === archivosPendientes.length) {
            toast.success(`${subidosConExito} archivo(s) subido(s) correctamente.`);
        } else {
            toast.warning(`Se subieron ${subidosConExito} de ${archivosPendientes.length} archivos.`);
        }
    };

    const handleEliminarArchivo = async (id) => {
        const archivo = archivos.find(a => a.id === id);
        if (!archivo) return;

        if (window.confirm(`¿Seguro que quieres eliminar "${archivo.nombre}"?`)) {
            if (archivo.esDelBackend) {
                try {
                    await eliminarArchivo(archivo.idArchivo);
                } catch (error) {
                    toast.error("Error al eliminar el archivo del servidor.");
                    return;
                }
            }
            setArchivos(prev => prev.filter(a => a.id !== id));
            toast.info(`Archivo "${archivo.nombre}" eliminado.`);
        }
    };

    const handleDescargarArchivo = async (archivo) => {
        if (!archivo.esDelBackend) {
            toast.info("El archivo debe subirse primero para poder descargarlo.");
            return;
        }
        try {
            const response = await descargarArchivo(archivo.idArchivo);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', archivo.nombre);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            toast.error("Error al descargar el archivo.");
        }
    };


    // Renderizado según el estado actual
    const renderizarEstado = () => {
        // Si el formulario de turno debe mostrarse, lo renderizamos en lugar del contenido del estado actual.
        if (mostrarFormularioTurno) {
            return (
                <FormularioTurno
                    visible={mostrarFormularioTurno}
                    onConfirmar={handleAsignarTurno}
                    onCancelar={() => setMostrarFormularioTurno(false)}
                    cargando={cargando}
                    medicos={medicos}
                    cargandoMedicos={cargandoMedicos}
                    lugares={lugares}
                    onLugarCreado={handleNuevoLugarCreado}
                />
            );
        }

        switch (tramite.idEstadoActual) {
            case 1: // Ingreso del Trámite
                return renderEstadoIngreso();
            case 2: // Turno Médico Asignado
                return renderEstadoTurnoAsignado();
            case 3: // Espera de Documentación
                return renderEstadoEsperaDocumentacion();
            case 4: // Aprobación Médica
                return renderEstadoAprobacionMedica();
            case 5: // Turno ANSES
                return <GestorEstadoTurnoAnses tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 6: // Turno Junta Médica
                return <GestorEstadoJuntaMedica tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 7: // Espera de 1° Dictamen
                return <GestorEstadoEsperaDictamen tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 9: // Primera Apelación
                return <GestorEstadoPrimeraApelacion tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 10: // Segunda Apelación
                return <GestorEstadoSegundaApelacion tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 11: // Trámite en Juicio (Instancia Judicial)
                return <GestorEstadoTramiteEnJuicio tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 15: // Espera Dictamen CMC
                return <GestorEstadoEsperaDictamenCMC tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 16: // Espera Fecha de Pericia
                return <GestorEstadoEsperaFechaPericia tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 17: // Pericia Asignada
                return <GestorEstadoPericiaAsignada tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 18: // Espera Dictamen Tribunal
                return <GestorEstadoEsperaDictamenTribunal tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            case 19: // Sentencia Judicial
                return <GestorEstadoSentenciaJudicial tramite={tramite} onEstadoCambiado={onEstadoCambiado} />;
            default:
                return null;
        }
    };

    // Renderizado Estado 1
    const renderEstadoIngreso = () => (
        <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-bold text-primary mb-0">
                    Ingreso del Trámite
                </h4>
                <span className="badge bg-info rounded-pill px-3 py-2">
                    Pendiente de Turno
                </span>
            </div>

            <div className="alert alert-info border-0 rounded-3">
                <div className="d-flex align-items-start">
                    <div>
                        <strong>Siguiente Paso:</strong>
                        <p className="mb-0 mt-1">
                            Asignar un turno médico para que el cliente sea evaluado.
                        </p>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center mt-3">
                <button
                    className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                    onClick={() => setMostrarFormularioTurno(true)}
                >
                    <CalendarMonthIcon fontSize="small" />
                    Asignar Turno
                </button>
            </div>
        </div>
    );

    // Renderizado Estado 2
    const renderEstadoTurnoAsignado = () => {

        if (cargandoTurno) {
            return <div className="alert alert-info">Cargando detalles del turno...</div>;
        }

        if (!turnoInfo) {
            return <div className="alert alert-warning">No se encontraron detalles del turno asignado.</div>;
        }

        // Parseamos los datos del evento para mostrarlos
        const descripcion = turnoInfo.descripcion || '';
        const medicoMatch = descripcion.match(/Médico: (.*?)(?:\s-|$)/);
        const lugarMatch = descripcion.match(/Lugar: (.*?)(?:\s-|$)/);
        const observacionesMatch = descripcion.match(/Observación: (.*?)(?:$)/);

        const fechaTurno = formatearFecha(turnoInfo.fecha);
        const horaTurno = turnoInfo.horaInicio || 'No especificada';
        const nombreMedico = medicoMatch ? medicoMatch[1] : 'No especificado';
        const lugarTurno = (turnoInfo.lugar && turnoInfo.lugar.trim())
            ? turnoInfo.lugar.trim()
            : (lugarMatch ? lugarMatch[1] : 'No especificado');
        const observacionesTurno = observacionesMatch ? observacionesMatch[1] : 'No especificadas';

        return (
            <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="fw-bold text-success mb-0">
                        Turno Médico Asignado
                    </h4>
                    <span className="badge bg-success rounded-pill px-3 py-2">
                    <EventAvailableIcon fontSize="small" className="me-1" />
                    Turno Confirmado
                </span>
                </div>

                {/* Tarjeta de detalle del turno */}
                <div className="card bg-light border-0 rounded-3 p-4 mb-3">
                    <h5 className="fw-semibold text-secondary mb-3">
                        Detalles del Turno
                    </h5>

                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <CalendarMonthIcon fontSize="small" className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Fecha</small>
                                    <strong className="text-dark">{fechaTurno}</strong>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <AccessTimeIcon fontSize="small" className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Hora</small>
                                    <strong className="text-dark">{horaTurno.slice(0, 5)}</strong>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <PersonIcon fontSize="small" className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Médico</small>
                                    <strong className="text-dark">{nombreMedico}</strong>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <PlaceIcon fontSize="small" className="text-primary me-2" />
                                <div>
                                    <small className="text-muted d-block">Lugar</small>
                                    <strong className="text-dark">{lugarTurno}</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    {observacionesTurno && (
                        <div className="mt-3 p-3 bg-white rounded-3 border">
                            <small className="text-muted d-block mb-1">Observación:</small>
                            <small className="text-dark" style={{ whiteSpace: 'pre-line' }}>
                                {observacionesTurno}
                            </small>
                        </div>
                    )}

                    <div className="mt-3 d-flex gap-2">
                        <BotonWhatsapp
                            idEvento={turnoInfo?.idEvento}
                            numeroTelefono={tramite.cliente?.telefonoPropio || tramite.cliente?.telefono}
                            nombreCliente={`${tramite.cliente?.nombre || ''} ${tramite.cliente?.apellido || ''}`.trim()}
                            contactosAdicionales={tramite.cliente?.contactos}
                            fechaTurno={turnoInfo?.fecha}
                            horaTurno={turnoInfo?.horaInicio || turnoInfo?.hora}
                            lugar={lugarTurno}
                            tipoEvento="Turno Médico"
                            tramiteId={tramite?.idTramite}
                            className="btn-sm"
                        />
                        <button
                            className="btn btn-sm btn-outline-success rounded-pill"
                            onClick={() => {
                                const medicoDelTurno = medicos.find(m => `${m.nombre} ${m.apellido}` === nombreMedico);
                                setIdMedicoParaGasto(medicoDelTurno ? medicoDelTurno.idMedico : null);
                                setMostrarModalGasto(true);
                            }}
                        >
                            <PaidIcon fontSize="small" className="me-1" />
                            Agregar Gasto Médico
                        </button>
                    </div>
                </div>
                {mostrarInputComentario ? (
                    <div className="mt-3">
                        <label htmlFor="comentarioEstudios" className="form-label fw-semibold">Detalle de estudios/documentos solicitados:</label>
                        <textarea
                            id="comentarioEstudios"
                            className="form-control"
                            rows="3"
                            value={comentarioEstudios}
                            onChange={(e) => setComentarioEstudios(e.target.value)}
                            placeholder="Ej: Se solicita radiografía de tórax y análisis de sangre completo."
                        ></textarea>
                        <div className="d-flex justify-content-end gap-2 mt-2">
                            <button className="btn btn-outline-secondary btn-sm" onClick={() => setMostrarInputComentario(false)}>Cancelar</button>
                            <button className="btn btn-primary btn-sm" onClick={handleConfirmarSolicitudEstudios} disabled={cargando}>
                                {cargando ? 'Guardando...' : 'Confirmar Solicitud'}
                            </button>
                        </div>
                    </div>
                ) : mostrarFormularioAprobacion ? (
                    <div className="mt-3">
                        <label htmlFor="observacionAprobacion" className="form-label fw-semibold">Observación de Aprobación Médica (opcional):</label>
                        <textarea
                            id="observacionAprobacion"
                            className="form-control"
                            rows="3"
                            value={observacionAprobacion}
                            onChange={(e) => setObservacionAprobacion(e.target.value)}
                            placeholder="Ej: Paciente apto para continuar con el trámite en ANSES."
                        ></textarea>
                        <div className="d-flex justify-content-end gap-2 mt-2">
                            <button className="btn btn-outline-secondary btn-sm" onClick={() => setMostrarFormularioAprobacion(false)} disabled={cargando}>Cancelar</button>
                            <button className="btn btn-success btn-sm" onClick={handleConfirmarAprobacionMedica} disabled={cargando}>
                                {cargando ? 'Confirmando...' : 'Confirmar Aprobación'}
                            </button>
                        </div>
                    </div>
                ) : !mostrarReprogramar ? (
                    <div className="d-flex flex-wrap justify-content-center gap-3">
                        <button
                            className="btn btn-warning d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={() => setMostrarReprogramar(true)}
                            disabled={cargando}
                        >
                            <EditCalendarIcon fontSize="small" />
                            Reprogramar
                        </button>

                        <button
                            className="btn btn-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={() => setMostrarModificar(true)}
                            disabled={cargando}
                            title="Corregir error de tipeo sin generar cambio de estado"
                        >
                            <EditCalendarIcon fontSize="small" />
                            Modificar Turno
                        </button>

                        <button
                            className="btn btn-danger d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={handleNoAsistio}
                            disabled={cargando}
                        >
                            <EventBusyIcon fontSize="small" />
                            No Asistió
                        </button>

                        <button
                            className="btn btn-info d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={() => setMostrarInputComentario(true)}
                            disabled={cargando}
                        >
                            <CheckCircleIcon fontSize="small" />
                            Solicitud de Estudios
                        </button>

                        <button
                            className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                            onClick={() => setMostrarFormularioAprobacion(true)}
                            disabled={cargando}
                        >
                            <CheckCircleIcon fontSize="small" />
                            Aprobación Médica
                        </button>
                    </div>
                ) : (
                    <div className="mt-4">
                        <h5 className="fw-semibold text-warning mb-3">Reprogramar Turno</h5>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">
                                Motivo de la reprogramación <span className="text-danger">*</span>
                            </label>
                            <textarea
                                className="form-control shadow-sm"
                                rows="2"
                                placeholder="Explique el motivo de la reprogramación..."
                                value={motivoReprogramacion}
                                onChange={(e) => setMotivoReprogramacion(e.target.value)}
                            />
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Nueva Fecha <span className="text-danger">*</span></label>
                                <div className="input-group">
                                <span className="input-group-text bg-light">
                                    <CalendarMonthIcon fontSize="small" />
                                </span>
                                    <input
                                        type="date"
                                        className="form-control shadow-sm"
                                        value={datosTurno.fecha}
                                        onChange={(e) => setDatosTurno({ ...datosTurno, fecha: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Nueva Hora <span className="text-danger">*</span></label>
                                <div className="input-group">
                                <span className="input-group-text bg-light">
                                    <AccessTimeIcon fontSize="small" />
                                </span>
                                    <input
                                        type="time"
                                        className="form-control shadow-sm"
                                        value={datosTurno.hora}
                                        onChange={(e) => setDatosTurno({ ...datosTurno, hora: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold">
                                    Médico <span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                <span className="input-group-text bg-light">
                                    <PersonIcon fontSize="small" />
                                </span>
                                    <select
                                        className="form-select shadow-sm"
                                        value={datosTurno.idMedico}
                                        onChange={(e) => setDatosTurno({ ...datosTurno, idMedico: e.target.value })}
                                        disabled={cargandoMedicos}
                                        required
                                    >
                                        <option value="">Seleccionar médico...</option>
                                        {medicos.map(medico => (
                                            <option key={medico.idMedico} value={medico.idMedico}>
                                                {medico.nombre} {medico.apellido} {medico.matricula ? `(Mat: ${medico.matricula})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {cargandoMedicos && (
                                    <small className="text-muted">Cargando médicos...</small>
                                )}
                            </div>

                            <div className="col-md-6">
                                <ComboboxDatosMaestros
                                    opciones={lugares.filter(l => l.tipo === 'Consultorio' || !l.tipo)}
                                    valor={datosTurno.lugar}
                                    onChange={(valor) => setDatosTurno({ ...datosTurno, lugar: valor })}
                                    tipo="lugar"
                                    tipoLugar="Consultorio"
                                    placeholder="Seleccione o escriba un lugar..."
                                    label="Lugar"
                                    icon={PlaceIcon}
                                    onCrearNuevo={handleNuevoLugarCreado}
                                />
                            </div>

                            <div className="col-12">
                                <label className="form-label fw-semibold">Observaciones</label>
                                <textarea
                                    className="form-control shadow-sm"
                                    rows="2"
                                    placeholder="Indicaciones adicionales..."
                                    value={datosTurno.observaciones}
                                    onChange={(e) => setDatosTurno({ ...datosTurno, observaciones: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <button
                                className="btn btn-warning d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={handleReprogramarTurno}
                                disabled={cargando || !motivoReprogramacion.trim() || !datosTurno.fecha || !datosTurno.hora || !datosTurno.idMedico}
                            >
                                {cargando ? (
                                    'Reprogramando...'
                                ) : (
                                    <>
                                        <EditCalendarIcon fontSize="small" />
                                        Confirmar Reprogramación
                                    </>
                                )}
                            </button>

                            <button
                                className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                onClick={() => {
                                    setMostrarReprogramar(false);
                                    setMotivoReprogramacion('');
                                    resetearFormulario();
                                }}
                                disabled={cargando}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // Renderizado Estado 3
    const renderEstadoEsperaDocumentacion = () => {
        const cambioEstadoDocumentacion = obtenerCambioMasRecientePorEstado(3);
        const comentario = (cambioEstadoDocumentacion?.comentario || '').trim() || 'No hay comentarios adicionales.';
        const archivosPendientes = archivos.some(a => a.estado === 'pendiente');

        return (
            <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="fw-bold text-info mb-0">Espera de Documentación</h4>
                    <span className="badge bg-info rounded-pill px-3 py-2">
                    <RuleFolderIcon fontSize="small" className="me-1" />
                    Pendiente de Archivos
                </span>
                </div>

                <div className="alert alert-info border-0 rounded-3">
                    <strong>Siguiente Paso:</strong>
                    <p className="mb-0 mt-1">Adjunte los archivos requeridos y luego valide la recepción para continuar.</p>
                </div>

                <div className="mt-1 p-3 bg-light rounded-3 border">
                    <small className="text-muted d-block mb-1">Estudios/Documentos Solicitados:</small>
                    <p className="text-dark mb-0" style={{ whiteSpace: 'pre-line' }}>{comentario}</p>
                </div>

                {/* --- GESTOR DE ARCHIVOS --- */}
                <div className="mt-4">
                    <h6 className="fw-semibold text-primary">Gestión de Archivos</h6>
                    {cargandoArchivos ? <p>Cargando archivos...</p> : (
                        <>
                            {archivos.length > 0 && (
                                <div className="list-group mb-3">
                                    {archivos.map(archivo => (
                                        <div key={archivo.id} className="list-group-item d-flex justify-content-between align-items-center">
                                            <div>
                                                <AttachFileIcon fontSize="small" className="me-2 text-muted" />
                                                <span className="fw-semibold">{archivo.nombre}</span>
                                                <small className="text-muted ms-2">({archivo.tamaño})</small>
                                                <span className={`badge ms-2 ${archivo.estado === 'subido' ? 'bg-success' : archivo.estado === 'error' ? 'bg-danger' : 'bg-warning text-dark'}`}>
                                                {archivo.estado}
                                            </span>
                                            </div>
                                            <div>
                                                {archivo.esDelBackend && (
                                                    <button className="btn btn-sm btn-outline-primary me-2" onClick={() => handleDescargarArchivo(archivo)} title="Descargar">
                                                        <DownloadIcon fontSize="small" />
                                                    </button>
                                                )}
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => handleEliminarArchivo(archivo.id)} title="Eliminar">
                                                    <DeleteIcon fontSize="small" />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div
                                className={`border rounded-3 p-4 text-center cursor-pointer ${dragActive ? "border-primary bg-primary bg-opacity-10" : "border-dashed"}`}
                                onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <input type="file" multiple ref={fileInputRef} onChange={handleSeleccionarArchivos} className="d-none" />
                                <CloudUploadIcon className="text-muted mb-2" />
                                <p className="mb-0">Arrastra archivos aquí o haz clic para seleccionar</p>
                            </div>

                            {archivosPendientes && (
                                <div className="d-flex justify-content-center mt-3">
                                    <button className="btn btn-primary rounded-pill px-4" onClick={handleSubirArchivos} disabled={subiendoArchivos}>
                                        {subiendoArchivos ? 'Subiendo...' : `Subir ${archivos.filter(a => a.estado === 'pendiente').length} archivo(s)`}
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* --- ACCIONES DE SALIDA --- */}
                { mostrarFormularioAprobacion ? (
                <div className="mt-3">
                    <label htmlFor="observacionAprobacion" className="form-label fw-semibold">Observación de Aprobación Médica (opcional):</label>
                    <textarea
                        id="observacionAprobacion"
                        className="form-control"
                        rows="3"
                        value={observacionAprobacion}
                        onChange={(e) => setObservacionAprobacion(e.target.value)}
                        placeholder="Ej: Paciente apto para continuar con el trámite en ANSES."
                    ></textarea>
                    <div className="d-flex justify-content-end gap-2 mt-2">
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => setMostrarFormularioAprobacion(false)} disabled={cargando}>Cancelar</button>
                        <button className="btn btn-success btn-sm" onClick={handleConfirmarAprobacionMedica} disabled={cargando}>
                            {cargando ? 'Confirmando...' : 'Confirmar Aprobación'}
                        </button>
                    </div>
                </div>
                ) : (
                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4 pt-3 border-top">
                    <button
                        className="btn btn-success d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                        onClick={() => setMostrarFormularioAprobacion(true)}
                        disabled={cargando || subiendoArchivos || archivosPendientes}
                        title={archivosPendientes ? "Debe subir todos los archivos pendientes primero" : "Marcar documentación como recibida y aprobada"}
                    >
                        <AssignmentTurnedInIcon fontSize="small" />
                        Validar Documentación y Aprobar
                    </button>
                    <button
                        className="btn btn-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                        onClick={() => setMostrarFormularioTurno(true)}
                        disabled={cargando || subiendoArchivos || archivosPendientes}
                        title={archivosPendientes ? "Debe subir todos los archivos pendientes primero" : "Asignar un nuevo turno de control"}
                    >
                        <EditCalendarIcon fontSize="small" />
                        Asignar Nuevo Turno
                    </button>
                </div>
                )}
            </div>
        );
    };

    const renderEstadoAprobacionMedica = () => {
        if (cargandoHistorial) {
            return (
                <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
                    <div className="alert alert-info">Cargando detalles de la aprobación...</div>
                </div>
            );
        }

        const cambioEstadoActual = obtenerCambioMasRecientePorEstado(4);
        const comentarioAprobacion = (cambioEstadoActual?.comentario || '').trim() || 'Sin observaciones.';
        const fechaAprobacion = cambioEstadoActual ? formatearFecha(obtenerFechaCambio(cambioEstadoActual)) : 'No disponible';

        // Intenta encontrar el último médico que intervino buscando en el historial.
        const ultimoTurno = historialEstados.find(h => [2, 3].includes(Number(h.idEstado)) && h.comentario && h.comentario.includes("Médico:"));
        let medicoAprobador = 'No especificado';
        if (ultimoTurno) {
            const medicoMatch = ultimoTurno.comentario.match(/Médico:\s(.*?)(?:\n|$)/);
            if (medicoMatch) medicoAprobador = medicoMatch[1].trim();
        }

        return (
            <div className="card shadow-lg border-0 rounded-4 p-4 mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="fw-bold text-success mb-0">Aprobación Médica</h4>
                    <span className="badge bg-success rounded-pill px-3 py-2">
                    <CheckCircleIcon fontSize="small" className="me-1" />
                    Apto para continuar
                </span>
                </div>

                <div className="alert alert-success border-0 rounded-3">
                    <strong>Siguiente Paso:</strong>
                    <p className="mb-0 mt-1">Derivar el trámite a ANSES para la asignación del turno correspondiente.</p>
                </div>

                {/* Tarjeta con los detalles de la aprobación */}
                <div className="mt-1 p-3 bg-light rounded-3 border">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <small className="text-muted d-block">Fecha de Aprobación</small>
                            <strong className="text-dark">{fechaAprobacion}</strong>
                        </div>
                        <div className="col-md-6">
                            <small className="text-muted d-block">Profesional</small>
                            <strong className="text-dark">{medicoAprobador}</strong>
                        </div>
                        <div className="col-12">
                            <small className="text-muted d-block mt-2">Observación</small>
                            <p className="text-dark mb-0" style={{ whiteSpace: 'pre-line' }}>{comentarioAprobacion}</p>
                        </div>
                    </div>
                </div>

                {/* Acciones de salida */}
                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4 pt-3 border-top">
                    <button
                        className="btn btn-primary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                        onClick={handleDerivarAAnses}
                        disabled={cargando}
                    >
                        <AssignmentTurnedInIcon fontSize="small" />
                        {cargando ? 'Derivando...' : 'Derivar a ANSES'}
                    </button>
                </div>
            </div>
        );
    };

    const handleGuardarModificacionEvento = async (idEvento, eventoActualizado) => {
        try {
            await EventoService.modificarEvento(idEvento, eventoActualizado);
            setMostrarModificar(false);
            await cargarTurnoActual();
            toast.success('Turno actualizado correctamente');
        } catch (error) {
            console.error('Error al modificar turno:', error);
            toast.error('No se pudo actualizar el turno');
        }
    };

    return (
        <>
            {renderizarEstado()}

            {/* Modal Agregar Gasto Médico */}
            <ModalAgregarGastoMedico
                open={mostrarModalGasto}
                onClose={() => setMostrarModalGasto(false)}
                onGastoAgregado={() => {
                    toast.success('Gasto médico agregado correctamente');
                    setMostrarModalGasto(false);
                }}
                preSelectedMedico={idMedicoParaGasto}
                preSelectedTramite={tramite.idTramite}
            />

            <ModificarEventoModal
                isOpen={mostrarModificar}
                onClose={() => setMostrarModificar(false)}
                evento={turnoInfo}
                onSave={handleGuardarModificacionEvento}
            />
        </>
    );
}

export default GestorEstadoTramite;
